import React from "react";
import { Button, Input, Select } from "antd";
import "./app_select_field.css";
import UtilBloc from "../../../bloc/util_bloc";
import { ReactComponent as DropDownIcon } from "../../../ArrowDownIcon.svg";
import { ReactComponent as InfoIcon } from "../../../Info2.svg";
import AppFieldError from "../form/app_field_error/app_field_error";
import GeneralBloc from "../../../bloc/general_bloc";

class AppSelectField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lastValue: 0,
            error: false,
        };
    }

    propPlaceholder() { return this.props.placeholder };

    propShowSearch() { return this.props.showSearch };

    propDisabled() { return this.props.disabled || false };

    propValue() { return this.props.value };

    propFieldNames() { return this.props.fieldNames || false };

    propTitle() { return this.props.title };

    propOptions() { return this.props.options };

    propTooltipEnabled = () => { return this.props.tooltipEnabled };

    propErrorLabelGetter() { return this.props.errorMessage };

    propErrorIndicator() { return this.props.error };

    propOnValidation(value) {
        if (this.props.onValidate) {
            this.setState({ error: this.props.onValidate(value) })
        }
    };

    onTooltipPress = () => {
        this.props.handleTooltipOpen();
    }

    onTextChange(val) {
        this.props.onChange(val);
    }

    render() {
        return (
            <div className="">
                <div className="d-flex my-1 align-items-center">
                    <span className="input_title">{this.propTitle()}</span>
                    {
                        this.props.tooltipEnabled === true &&
                        <Button type='text' className="ml-1 p-0" style={{ height: '100%' }} onClick={() => this.onTooltipPress()} >
                            <InfoIcon />
                        </Button>
                    }

                </div>
                <div className="mt-2"
                    style={{
                        height: '48px',
                        border: (this.propErrorIndicator() || this.state.error) ? '1px solid #FC5A5A' : '1px solid rgba(224, 224, 224, 1)',
                        borderRadius: '2px',
                        backgroundColor: this.propDisabled() ? '#f5f5f5' : 'white',
                        position: 'relative'
                    }}
                >
                    <Select
                        placeholder={<div>{this.propShowSearch() && <img
                            src={
                                GeneralBloc.getAssetsContextPath() +
                                `/assets/icons/Search.svg`
                            }
                            alt="Search"
                            className="mr-2"
                        />}{this.propPlaceholder()}</div>}
                        variant='borderless'
                        bordered={false}
                        size={"large"}
                        suffixIcon={<DropDownIcon />}
                        value={this.propValue() || undefined}
                        style={{ width: '100%', color: this.propDisabled() ? 'rgba(0,0,0,0.25)' : 'rgba(0,0,0,1)' }}
                        disabled={this.propDisabled()}
                        onChange={(e) => {
                            this.propOnValidation(e);
                            this.onTextChange(e);
                        }}
                        options={this.propOptions()}
                        optionFilterProp={this.propFieldNames() ? this.propFieldNames().label : 'label'}
                        showSearch={this.propShowSearch()}
                        onSearch={(e) => this.onTextChange(e)}
                        fieldNames={this.propFieldNames()}
                    ></Select>
                </div>
                <div style={{ display: "block", width: "100%", height: '15px' }}>
                    {
                        (this.propErrorIndicator() || this.state.error) &&
                        <AppFieldError
                            text={this.propErrorLabelGetter()}
                        />
                    }
                </div>

            </div>
        );
    }
}

export default AppSelectField;
